import axios from 'axios'
import { Message } from 'iview'
import { getToken } from '@/libs/util'
import config from '@/config'
import router from '@/router'
const baseURL = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro
const service = axios.create({
  baseURL: baseURL,
  timeout: 10000 // 请求超时时间
})

axios.defaults.withCredentials = true// 携带cookie

// 请求拦截器
service.interceptors.request.use(
  config => {
    config.baseURL = baseURL
    const token = getToken('token')
    if (token) {
      config.headers['Authori-zation'] = token
    }
    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const contentType = response.headers['content-type']
    // 检查是否是 Blob 数据
    if (contentType && contentType.startsWith('image/')) {
      return response
    }

    const code = response.data ? response.data.code : 0
    switch (code) {
      case 200:
        return response.data
      case 400:
        return Promise.reject(response.data || { msg: '未知错误' })
      case 410000:
        localStorage.clear()
        removeCookies('token')
        removeCookies('expires_time')
        router.replace({ path: '/admin/login' })
        break
      default:
        break
    }
  },
  error => {
    Message.error(error.msg)
    return Promise.reject(error)
  }
)

export default service
